import { iamUrl } from "./config";
import { loginUrl } from "./constant";
import { get, post, postFile } from "./httpInterceptor";
import axios from "axios";

// GET PanDetails API
export const PanDetails = data => {
  return post(`/growth-source/api/getPanDetails`, data).then(res => {
    console.log("Response :: Get Pan Details ::: ", res);
    return res;
  });
};

// GET Gst Number
export const GstNumber = data => {
  return post(`/growth-source/api/getGSTNumber`, data).then(res => {
    console.log("Response :: Get GST Numbers ::: ", res);
    return res;
  });
};

// GST Address Details
export const Gstaddress = data => {
  return post(`/growth-source/api/getGSTAddressDetails`, data).then(res => {
    console.log("Response :: Get GST Address Details ::: ", res);
    return res;
  });
};

// Get All States
// export const getAllState = data => {
//   return post(`/growth-source/common/getAllStates`, data).then(res => {
//     console.log("Response :: Get All states ::: ", res);
//     return res;
//   });
// };

// get All Cities
export const getAllState = () => {
  return get(`/growth-source/common/getAllStates`).then(res => {
    console.log("Response :: Get All states ::: ", res);
    return res;
  });
};

export const getAllCities = data => {
  return get(`/growth-source/common/getCity?state=${data}`).then(res => {
    console.log("Response :: Get All City ::: ", res);
    return res;
  });
};
export const getAllBranch = data => {
  return get(`/growth-source/common/getbranchname?pincode=${data}`).then(res => {
    console.log("Response :: Get All Branch ::: ", res);
    return res;
  });
};

// add DSA API
export const AddDSA = data => {
  return post(`/growth-source/dsa/addDsa`, data).then(res => {
    console.log("Response :: Add Dsa Data ::: ", res);
    return res;
  });
};
// getCompanytypeList Api
export const getCompanytypeList = data => {
  return post(`/growth-source/common/getSubcategorylist?categoryid=${2}`).then(
    res => {
      console.log("Response :: Get Company List ::: ", res);
      return res;
    }
  );
};
//Get all Dsa List for checker
export const getAllDSA = data => {
  return post(`/growth-source/dsa/getdsalist?status=${data}`).then(res => {
    console.log("Response :: Get DSA List ::: ", res);
    return res;
  });
};
// Get DsaByUniqueId
export const getDsaByUniqueId = data => {
  return post(`/growth-source/dsa/getDsaByUniqueId?dsacode=${data}`).then(
    res => {
      console.log("Response :: Get DSA BY UniqueId ::: ", res);
      return res;
    }
  );
};

// Upload Document
export const uploadDoc = (data, zip) => {
  console.log("Object Data", data);
  return postFile(
    `/growth-source/dsa/uploadDoc?dsaDocs=${encodeURIComponent(
      JSON.stringify(data)
    )}
    `,
    zip,
    "multipart/form-data"
  ).then(res => {
    console.log("RESPONSE :: Upload Document ::: ", res);
    return res;
  });
};
//Is mobile number present
export const postIsMobileNumberPresent = mobileNumber => {
  return post(
    `/growth-source/user/isMobileNumberPresent?mobileNumber=${mobileNumber}`
  ).then(res => {
    console.log("Response :: Post Is mobile number present ::: ", res);
    return res;
  });
};
//Is email is already exist
export const postIsEmailExist = email_address => {
  return post(
    `/growth-source/user/isemailIdPresent?emailId=${email_address}`
  ).then(res => {
    console.log("Response :: Post Is email address present ::: ", res);
    return res;
  });
};
/*
//Get Branch List
export const BranchList = data => {
  return post(`/growth-source/common/getBranchlist`, data).then(res => {
    console.log("Response :: Get Branch List ::: ", res);
    return res;
  });
};
*/

export const iamLogout = async(data) => {
 try{
  const response  = await axios.post(`${iamUrl}/iam/v1.0/logout`, data, {
    headers: {
      "Content-Type" : "application/json",
    },
    withCredentials: true,
  })
  console.log("respo: ", response)
  if(response.status === 200){
    localStorage.clear();
    const hostname = window.location.hostname;
    let loginUrl;
    if (hostname === "central-admin.sarvagram.com") {
      loginUrl = "https://central-admin.sarvagram.com/#/login";
    } else if (hostname === "uat-central-admin.sarvagram.net") {
      loginUrl = "https://uat-central-admin.sarvagram.net/#/login";
    } else if (hostname === "localhost" || hostname === "127.0.0.1") {
      // For localhost, use current origin
      loginUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/#/login`;
    } else {
      loginUrl = "https://dev-central-admin.sarvagram.net/#/login";
    }
    window.location.href = loginUrl;
  }else{
    console.log("issue while loging out")
  }
 }catch(err){
  console.log("issue while loging out", err)
 }
}

export const userInfo = (userId) => {
  return get(`/user/${userId}`).then(res => {
    console.log("Response :: Get User Info ::: ", res.data);
    const obj = {
      employeeId: res?.data?.employeeId,
      role: res?.data?.role,
      employeeName: res?.data?.employeeName
    }
    localStorage.setItem('userInfo', JSON.stringify(obj));
    return res;
  });
};